import { createAsyncThunk } from '@reduxjs/toolkit';
import { Paginated, PaginationService } from '../../services/api-handlers/pagination';
import { resolveApiCall } from '../../services/api-handlers/api-resolver';
import QuizAnswerApi from '../../services/end-points/quiz-answer-api';
import { QuizQuestionApi } from '../../services/end-points';
import SortingService from '../../services/sorting';
import { QueryParams, QuizAnswer, QuizQuestion } from '../../types';
import { makeFormErrorsFromResponse } from '../../components/react-hook-form/utils/make-form-errors';
import { ThunkConfig } from '../configure-store';

export const listQuizQuestions = createAsyncThunk<Paginated<QuizQuestion>, QueryParams, ThunkConfig>(
    'quiz/list',
    async (payload, thunkAPI) => {
        const { getState } = thunkAPI;
        const { quiz } = getState();
        const { filters, sorting, ...rest } = payload;

        return PaginationService.resolveApiCall(
            thunkAPI,
            quiz,
            async () =>
                QuizQuestionApi.list({
                    ...filters,
                    ...SortingService.makeOrder(sorting),
                    ...rest,
                }),
            payload.page,
            quiz.data,
        );
    },
);

export const updateQuizQuestion = createAsyncThunk<
    Paginated<QuizQuestion>,
    { id: QuizQuestion['id']; data: { title: string } },
    ThunkConfig
>('quiz/update-question', async (payload, thunkApi) => {
    const { getState } = thunkApi;
    const { quiz } = getState();
    const { id, data } = payload;
    return resolveApiCall(
        thunkApi,
        quiz,
        async () => await QuizQuestionApi.update(id, data),
        async (err) => {
            const { response } = err;
            return makeFormErrorsFromResponse(response.data);
        },
    );
});

export const updateQuizAnswer = createAsyncThunk<
    Paginated<QuizQuestion>,
    { id: QuizAnswer['id']; data: { title: string } },
    ThunkConfig
>('quiz/update-answer', async (payload, thunkApi) => {
    const { getState } = thunkApi;
    const { quiz } = getState();
    const { id, data } = payload;
    return resolveApiCall(
        thunkApi,
        quiz,
        async () => await QuizAnswerApi.update(id, data),
        async (err) => {
            const { response } = err;
            return makeFormErrorsFromResponse(response.data);
        },
    );
});
